<template>
  <b-button size="sm" variant="primary" @click="$emit('click')" aria-label="print">
    <i class="fa fa-print"></i>
  </b-button>
</template>

<script>
export default {
  name: 'VsmPrintButton',
}
</script>
